module.exports = __webpack_public_path__ + "static/img/index_banner.34a64c5a.png";